import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/pfc";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function NewsletterConfirm() {
  const { token } = useParams();
  const [state, setState] = useState({ status: "loading", email: null });

  useEffect(() => {
    api.get(`/newsletter/confirm/${token}`)
      .then((r) => setState({ status: r.data.status, email: r.data.email }))
      .catch(() => setState({ status: "invalid", email: null }));
  }, [token]);

  return (
    <div className="max-w-[700px] mx-auto px-5 lg:px-10 py-24 text-center" data-testid="newsletter-confirm-page">
      {state.status === "loading" && (
        <>
          <Loader2 className="mx-auto text-pfc-gold animate-spin mb-6" size={48} />
          <p className="label text-pfc-gold">Confirming…</p>
        </>
      )}
      {(state.status === "confirmed" || state.status === "already_confirmed") && (
        <div data-testid="newsletter-confirmed">
          <CheckCircle2 className="mx-auto text-pfc-gold mb-6" size={64} />
          <div className="label text-pfc-gold mb-3">You’re In</div>
          <h1 className="font-display text-5xl text-white uppercase leading-[0.95]">Welcome to the <span className="gold-text">List.</span></h1>
          <p className="text-white/70 mt-6 font-body text-lg">
            <strong className="text-pfc-gold">{state.email}</strong> is now confirmed for the PFC weekly digest. Expect Sunday-night drops with cover stories, talent breakthroughs, and event invites.
          </p>
          <Link to="/" className="inline-block mt-10 font-sub uppercase tracking-[0.25em] text-sm px-8 py-4 bg-pfc-gold text-ink-900 hover:bg-pfc-gold-bright transition" data-testid="newsletter-home-btn">
            Back to Home
          </Link>
        </div>
      )}
      {state.status === "invalid" && (
        <div data-testid="newsletter-invalid">
          <XCircle className="mx-auto text-pfc-red mb-6" size={64} />
          <div className="label text-pfc-red mb-3">Invalid Link</div>
          <h1 className="font-display text-4xl text-white uppercase">This confirmation link is <span className="gold-text">expired</span> or already used.</h1>
          <Link to="/" className="inline-block mt-8 font-sub uppercase tracking-[0.25em] text-sm px-8 py-4 border border-white/20 text-white hover:border-pfc-gold transition">
            Subscribe again
          </Link>
        </div>
      )}
    </div>
  );
}
